// extracted by mini-css-extract-plugin
export default {"conflictSection":"ConflictSection_conflictSection__+ozHS","icon":"ConflictSection_icon__lofnx","title":"ConflictSection_title__6YYK9"};